var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "weekly-plan row" },
    _vm._l(_vm.projectArr, function(project, index) {
      return _c("div", { staticClass: "col" }, [
        _c("div", { staticClass: "m-portlet mt-4" }, [
          _c("div", { staticClass: "m-portlet__head" }, [
            _c("div", { staticClass: "m-portlet__head-caption" }, [
              _c("div", { staticClass: "m-portlet__head-title" }, [
                _c("h3", { staticClass: "m-portlet__head-text" }, [
                  _vm._v("\n                            KW " + _vm._s(index)),
                  project.current
                    ? _c("span", [_vm._v(" (aktuelle Woche)")])
                    : _vm._e()
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "m-portlet__body" }, [
            _c("div", [
              _c(
                "div",
                [
                  _c("h5", [_vm._v("Auslastung in Stunden")]),
                  _vm._v(" "),
                  project.sumHoursToWork > 0
                    ? _c("div", { staticClass: "row" }, [
                        _c(
                          "div",
                          {
                            staticClass: "col-12 d-flex align-items-center mb-1"
                          },
                          [
                            _c("b", [
                              _vm._v(_vm._s(project.sumHoursPlanned) + "h")
                            ]),
                            _vm._v(" von "),
                            _c("b", [
                              _vm._v(_vm._s(project.sumHoursToWork) + "h")
                            ]),
                            _vm._v(" (unterwegs: "),
                            _c("b", [
                              _vm._v(_vm._s(project.sumHoursOnWay) + "h")
                            ]),
                            _vm._v(") geplant")
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-12 d-flex align-items-center" },
                          [
                            _c("el-progress", {
                              staticClass: "w-100",
                              attrs: {
                                color: _vm.customColorMoney,
                                "show-text": false,
                                percentage: project.sumHoursPerc
                              }
                            })
                          ],
                          1
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("h5", { staticClass: "mt-4" }, [_vm._v("Budget")]),
                  _vm._v(" "),
                  project.sumMoneyNeed > 0
                    ? _c("div", { staticClass: "row" }, [
                        _c(
                          "div",
                          { staticClass: "col-12 d-flex align-items-center" },
                          [
                            _c("b", [
                              _vm._v(
                                _vm._s(_vm._f("currency")(project.sumMoney))
                              )
                            ]),
                            _vm._v(" von "),
                            _c("b", [
                              _vm._v(
                                _vm._s(_vm._f("currency")(project.sumMoneyNeed))
                              )
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-12 d-flex align-items-center" },
                          [
                            _c("el-progress", {
                              staticClass: "w-100",
                              attrs: {
                                color: _vm.customColorMoney,
                                "show-text": false,
                                percentage: project.sumMoneyPerc
                              }
                            })
                          ],
                          1
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("hr", { staticClass: "mt-4" }),
                  _vm._v(" "),
                  _c("h5", [_vm._v("TODO in Stunden")]),
                  _vm._v(" "),
                  project.sumHoursToWork > 0
                    ? _c("div", { staticClass: "row" }, [
                        _c(
                          "div",
                          {
                            staticClass: "col-12 d-flex align-items-center mb-1"
                          },
                          [
                            _c("b", [
                              _vm._v(_vm._s(project.sumHoursToDo) + "h")
                            ]),
                            _vm._v(" von "),
                            _c("b", [
                              _vm._v(_vm._s(project.sumHoursPlanned) + "h")
                            ]),
                            _vm._v(" Stunden offen")
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-12 d-flex align-items-center" },
                          [
                            _c("el-progress", {
                              staticClass: "w-100",
                              attrs: {
                                color: _vm.customColorMoney,
                                "show-text": false,
                                percentage: project.sumHoursToDoPerc
                              }
                            })
                          ],
                          1
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("h5", { staticClass: "mt-4" }, [
                    _vm._v("TODO in Projekten")
                  ]),
                  _vm._v(" "),
                  project.sumHoursToWork > 0
                    ? _c("div", { staticClass: "row" }, [
                        _c(
                          "div",
                          {
                            staticClass: "col-12 d-flex align-items-center mb-1"
                          },
                          [
                            _c("b", [
                              _vm._v(_vm._s(project.sumProjectsToPhoto))
                            ]),
                            _vm._v(" von "),
                            _c("b", [_vm._v(_vm._s(project.sumProjects))]),
                            _vm._v(" Projekte offen")
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-12 d-flex align-items-center" },
                          [
                            _c("el-progress", {
                              staticClass: "w-100",
                              attrs: {
                                color: _vm.customColorMoney,
                                "show-text": false,
                                percentage: project.sumProjectsPerc
                              }
                            })
                          ],
                          1
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("h5", { staticClass: "mt-4" }, [
                    _vm._v("Mitarbeiterauslastung")
                  ]),
                  _vm._v(" "),
                  _vm._l(project.employees, function(employee) {
                    return employee.workload > 0
                      ? _c("div", { staticClass: "row mb-3" }, [
                          _c(
                            "div",
                            { staticClass: "col-3 d-flex align-items-center" },
                            [_vm._v(_vm._s(employee.name))]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-2 d-flex align-items-center" },
                            [_vm._v(_vm._s(employee.workload) + "h")]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-5 d-flex align-items-center" },
                            [
                              _c("el-progress", {
                                staticClass: "w-100",
                                attrs: {
                                  color: _vm.customColors,
                                  "show-text": false,
                                  percentage:
                                    (employee.workload /
                                      employee.employeeHoursPerWeek) *
                                    100
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-2 d-flex align-items-center" },
                            [_vm._v("33h")]
                          )
                        ])
                      : _vm._e()
                  })
                ],
                2
              )
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "m-portlet__body" },
            [
              _vm._l(project.inquiries, function(projectDetail) {
                return _c("div", [
                  _c(
                    "div",
                    {
                      staticClass:
                        "m-portlet m-portlet--head-solid-bg m-portlet--head-sm  m-portlet--sortable js-project-portlet prio-1",
                      attrs: { "data-portlet": "true" }
                    },
                    [
                      _vm._m(0, true),
                      _vm._v(" "),
                      _c("div", { staticClass: "m-portlet__body pl-2 pr-2" }, [
                        _c("div", { staticClass: "row pt-1 pb-1" }, [
                          _c("div", { staticClass: "col-2" }, [
                            projectDetail.client
                              ? _c("span", [
                                  _c(
                                    "a",
                                    {
                                      attrs: {
                                        target: "_blank",
                                        href:
                                          "/kunde-" + projectDetail.client_id
                                      }
                                    },
                                    [_vm._v(_vm._s(projectDetail.client_id))]
                                  )
                                ])
                              : _vm._e()
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-10" }, [
                            projectDetail.client
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "js-project-portlet__clientName"
                                  },
                                  [
                                    projectDetail.client.company
                                      ? _c("span", [
                                          _vm._v(
                                            _vm._s(projectDetail.client.company)
                                          )
                                        ])
                                      : _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              projectDetail.client.sex_id
                                            ) +
                                              " " +
                                              _vm._s(
                                                projectDetail.client.prename
                                              ) +
                                              " " +
                                              _vm._s(projectDetail.client.name)
                                          )
                                        ])
                                  ]
                                )
                              : _c("div", [
                                  _c("b", [
                                    projectDetail.firma
                                      ? _c("span", [
                                          _vm._v(_vm._s(projectDetail.firma))
                                        ])
                                      : _c("span", [
                                          _vm._v(
                                            _vm._s(projectDetail.salutation) +
                                              " " +
                                              _vm._s(projectDetail.pre_name) +
                                              " " +
                                              _vm._s(projectDetail.name)
                                          )
                                        ])
                                  ])
                                ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "js-project-portlet__name" },
                              [
                                _c(
                                  "a",
                                  {
                                    attrs: {
                                      target: "_blank",
                                      href: "/anfrage-" + projectDetail.id
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(projectDetail.produkttyp) +
                                        " " +
                                        _vm._s(projectDetail.produkt)
                                    )
                                  ]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "mb-2 " }, [
                              _c("b", [
                                _vm._v(
                                  _vm._s(projectDetail.exact_amount) +
                                    " Bilder in " +
                                    _vm._s(projectDetail.working_hours) +
                                    "h"
                                )
                              ])
                            ])
                          ])
                        ])
                      ])
                    ]
                  )
                ])
              }),
              _vm._v(" "),
              _vm._l(project.projects, function(projectDetail) {
                return _c("div", [
                  _c(
                    "div",
                    {
                      staticClass:
                        "m-portlet m-portlet--head-solid-bg m-portlet--head-sm  m-portlet--sortable js-project-portlet",
                      class:
                        projectDetail.current_status_id < 6
                          ? "prio-2"
                          : "prio-5",
                      attrs: { "data-portlet": "true" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "m-portlet__head pl-2 pr-2 pt-2 pb-2",
                          staticStyle: { height: "auto !important" }
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "m-portlet__head-caption" },
                            [
                              projectDetail.current_status_id >= 6
                                ? _c("div", [
                                    _vm._v(
                                      "Projekt - " +
                                        _vm._s(projectDetail.status_name)
                                    )
                                  ])
                                : _c("div", { staticClass: "text-primary" }, [
                                    _c("b", [
                                      _vm._v(
                                        "Projekt - " +
                                          _vm._s(projectDetail.status_name)
                                      )
                                    ])
                                  ])
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "m-portlet__body pl-2 pr-2" }, [
                        _c("div", { staticClass: "row pt-1 pb-1" }, [
                          _c("div", { staticClass: "col-2" }, [
                            _c("span", [
                              _c(
                                "a",
                                {
                                  attrs: {
                                    target: "_blank",
                                    href: "/kunde-" + projectDetail.client_id
                                  }
                                },
                                [_vm._v(_vm._s(projectDetail.client_id))]
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-10" }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "js-project-portlet__clientName mb-2"
                              },
                              [
                                projectDetail.client.company
                                  ? _c("span", [
                                      _vm._v(
                                        _vm._s(projectDetail.client.company)
                                      )
                                    ])
                                  : _c("span", [
                                      _vm._v(
                                        _vm._s(projectDetail.client.sex_id) +
                                          " " +
                                          _vm._s(projectDetail.client.prename) +
                                          " " +
                                          _vm._s(projectDetail.client.name)
                                      )
                                    ])
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "js-project-portlet__name" },
                              [
                                _c(
                                  "a",
                                  {
                                    attrs: {
                                      target: "_blank",
                                      href: "/projekt-" + projectDetail.id
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        projectDetail.client_project_count
                                      ) +
                                        " - " +
                                        _vm._s(projectDetail.name)
                                    )
                                  ]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "mb-2" }, [
                              _c("b", [
                                _vm._v(
                                  _vm._s(projectDetail.exact_amount) +
                                    "x Bilder in " +
                                    _vm._s(projectDetail.working_hours_calc) +
                                    "h"
                                )
                              ]),
                              _c("br"),
                              _vm._v(" "),
                              _c("b", { staticClass: "text-success" }, [
                                _vm._v(
                                  _vm._s(_vm._f("currency")(projectDetail.sum))
                                )
                              ])
                            ])
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "row" }, [
                          _c("div", { staticClass: "col-6" }, [
                            _c("i", { staticClass: "fa fa-cog" }),
                            _vm._v("  "),
                            projectDetail.manager
                              ? _c(
                                  "span",
                                  {
                                    staticClass: "js-project-portlet__manager"
                                  },
                                  [_vm._v(_vm._s(projectDetail.manager.name))]
                                )
                              : _vm._e()
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-6" }, [
                            _c("i", { staticClass: "fa fa-camera" }),
                            _vm._v("  "),
                            projectDetail.photographer
                              ? _c(
                                  "span",
                                  {
                                    staticClass:
                                      "js-project-portlet__photographer"
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(projectDetail.photographer.name)
                                    )
                                  ]
                                )
                              : _vm._e()
                          ])
                        ])
                      ])
                    ]
                  )
                ])
              })
            ],
            2
          )
        ])
      ])
    }),
    0
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "m-portlet__head pl-2 pr-2 pt-2 pb-2",
        staticStyle: { height: "auto !important" }
      },
      [
        _c("div", { staticClass: "m-portlet__head-caption" }, [
          _c("div", [_vm._v("Anfrage - Paket unterwegs")])
        ])
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }